import Markdown from 'react-markdown';

export default Markdown;
